/**
 * Project Row Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.projectRowDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
